import { useRouter } from '@application/utils';

export const useSeo = () => {
  const { translate } = useRouter();

  const seoTitle = translate('links.litters.seo.title');

  const seoDescription = translate('links.litters.seo.description');

  const pageTitle = translate('links.litters.title');

  return { seoDescription, seoTitle, pageTitle };
};
